import Logger from '@medflex/utils/Logger';
import makeApiRequest from '../../../api/makeApiRequest';

const physicianInvitation = {
  name: 'physicianInvitation',
  state: { pending: {}, redeemed: {}, invitations: [] },
  effects: dispatch => ({
    async create(payload, { oidcSession }) {
      const body = {
        data: {
          attributes: payload,
        },
      };
      const url = '/physician-invitations';
      const [request] = makeApiRequest({ url, method: 'post', data: body }, oidcSession);
      const { error, status } = await request;
      if (!error) return this.updatePending(payload);
      if (status === 409) return this.updatePending({ isAlreadyContact: true });
      Logger.error(error);
      throw new Error();
    },
    async redeem({ id, inviterName }, { oidcSession }) {
      const config = {
        url: `/physician-invitations/${id}`,
        method: 'patch',
        data: {
          data: {
            type: 'physician-invitations-permanent',
            attributes: {
              id,
            },
          },
        },
      };
      const [request] = makeApiRequest(config, oidcSession);
      const { data, error, status } = await request;
      if (!error) {
        const attributes = { inviterName, id: data.data.attributes.contact.id };
        this.updateRedeemed(attributes);
        dispatch.messageEvents.onMessage({
          type: 'CONTACT_CREATED',
          payload: data.data.attributes.contact,
        });
      } else {
        const ERRORS = {
          404: () => this.notFound(),
          400: () => this.isSelf(),
        };
        if (ERRORS[status]) ERRORS[status]();
        else throw error;
      }
    },
  }),
  reducers: {
    updatePending: (state, data) => ({ ...state, pending: { ...data } }),
    cleanupPending: state => ({ ...state, pending: {} }),
    updateRedeemed: (state, redeemed) => ({ ...state, redeemed: { ...redeemed } }),
    notFound: state => ({ ...state, redeemed: { notFound: true } }),
    isSelf: state => ({ ...state, redeemed: { isSelf: true } }),
  },
};

export default physicianInvitation;
